
$(document).ready(function(){

	var $slideshow_SlidesToShow = 3;
	var $slideshow_SlidesToShow_Tablet = 2;
	var $slideshow_SlidesToShow_Mobile = 1;

	var $slideshow_variableWidth = false;
	var $slideshow_adaptiveHeight = false;
	var $slideshow_centerMode = false;

	var $slideshow_fade = false;
	var $slideshow_speed = 500;
	var $slideshow_autoplay = false;
	var $slideshow_autoplaySpeed = 10000;


	$('.slideshow').each(function(){

		var $slideshow = $(this);
		var $slideshowStatus = $slideshow.find('.slideshow__status');
		var $slideshowArrows = $slideshow.find('.slideshow__arrow');


		$('.slideshow__wrap').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {


			// currentSlide is undefined on init - set it to 0 in this case (currentSlide is 0 based)

			var i = (currentSlide ? currentSlide : 0) + 1;


			// Append current slide's number and total number of slides for a compact replacement of the dot nav on mobile

	        $slideshowStatus.html('<span>' + i + '</span>' + '/' + '<span>' + slick.slideCount + '</span>');


			// Get slideshow track height to vertically align nav arrows

			var $trackHeight = {};

	        if ( $slideshow.hasClass("slideshow--image") ) {

				// Image slideshow -
				$trackHeight =  $slideshow.find('.slick-track .image').filter(":first").height();

			} else {

				// Regular slideshow - teaser etc
				// TODO: Use 'height' on '.slick-track', once no padding/margin hack for shadows is used
			    $trackHeight =  $slideshow.find('.slick-list').outerHeight();

			};

			// var $trackCenter = ( $trackHeight / 2 );

			$slideshowArrows.css("top", ( $trackHeight / 2 ));

    	});


    	// var currentSlide = $slideshow.slick('slickCurrentSlide');

		// Setting the max numbers of slides shown

		if ( $(this).hasClass("slideshow--col-1") ) {
			$slideshow_SlidesToShow = 1;
			$slideshow_SlidesToShow_Tablet = 1;
			$slideshow_SlidesToShow_Mobile = 1;
		}

		if ( $(this).hasClass("slideshow--col-2") ) {
			$slideshow_SlidesToShow = 2;
			$slideshow_SlidesToShow_Tablet = 2;
			$slideshow_SlidesToShow_Mobile = 1;
		}

		if ( $(this).hasClass("slideshow--col-4") ) {
			$slideshow_SlidesToShow = 4;
			$slideshow_SlidesToShow_Tablet = 3;
			$slideshow_SlidesToShow_Mobile = 2;
		}

		if ( $(this).hasClass("slideshow--col-5") ) {
			$slideshow_SlidesToShow = 5;
			$slideshow_SlidesToShow_Tablet = 3;
			$slideshow_SlidesToShow_Mobile = 2;
		}

		// Setting the handling of differently sized images

		if ( $slideshow.attr("data-params-variableWidth") ) {
			$slideshow_variableWidth = true;
		}

		if ($slideshow.attr("data-params-centerMode") ) {
			$slideshow_centerMode = true;
		}

		if ( $slideshow.attr("data-params-fade") ) {
			$slideshow_fade = true;
		}

		if ( $slideshow.attr("data-params-speed") ) {
			$slideshow_speed = $slideshow.attr("data-params-speed");
		}

		if ( $slideshow.attr("data-params-autoplay") ) {
			$slideshow_autoplay = true;
			$slideshow_autoplaySpeed = $slideshow.attr("data-params-autoplay");
		}

		if ( $slideshow.attr("data-params-adaptiveHeight") ) {
			$slideshow_adaptiveHeight = true;
			$slideshow_SlidesToShow = 1;
			$slideshow_SlidesToShow_Tablet = 1;
			$slideshow_SlidesToShow_Mobile = 1;
		}



		$(".slideshow__wrap",this).slick({
			slidesToShow : $slideshow_SlidesToShow,
			slidesToScroll: $slideshow_SlidesToShow,
			arrows : true,
			prevArrow: $slideshow.find('.slideshow__arrow--prev'),
			nextArrow: $slideshow.find('.slideshow__arrow--next'),
			dots: true,
			appendDots: $slideshow.find(".slideshow__dots"),
			slide : '.slideshow__item',
			fade: $slideshow_fade,
			speed: $slideshow_speed,
			autoplay : $slideshow_autoplay,
			autoplaySpeed : $slideshow_autoplaySpeed,
			variableWidth : $slideshow_variableWidth,
			centerMode: $slideshow_centerMode,
			adaptiveHeight: $slideshow_adaptiveHeight,
			responsive : [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: $slideshow_SlidesToShow_Tablet,
						slidesToScroll: $slideshow_SlidesToShow_Tablet
					}
				},
				{
					breakpoint: 720,
					settings: {
						slidesToShow: $slideshow_SlidesToShow_Mobile,
						slidesToScroll: $slideshow_SlidesToShow_Mobile,
						dots: true,
						variableWidth : false,
						adaptiveHeight : false
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						variableWidth : false,
						adaptiveHeight : false
					}
				}
			]
		});

		$slideshow_SlidesToShow = 3;
		$slideshow_SlidesToShow_Tablet = 2;
		$slideshow_SlidesToShow_Mobile = 1;

		$slideshow_variableWidth = false;
		$slideshow_adaptiveHeight = false;
		$slideshow_centerMode = false;

		$slideshow_fade = false;
		$slideshow_speed = 500;
		$slideshow_autoplay = false;
		$slideshow_autoplaySpeed = 10000;

	});

	// var haha = $(".slideshow__wrap").slick('slickGetOption', 'slidesToShow');
	// console.log(haha);

});